import { render, staticRenderFns } from "./basicinfo-notificationPreferences.vue?vue&type=template&id=3dcffdd4"
import script from "./basicinfo-notificationPreferences.vue?vue&type=script&lang=js"
export * from "./basicinfo-notificationPreferences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports